import { useContext } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom';

import { userContext } from "./contextAdmin/Admin/User"

import MainAdmin from './components/Admin/MainAdmin/MainAdmin';
import { popupContext } from './contextAdmin/Admin/Popup';
import Login from './pages/Admin/Login/Login';
import Header from './components/Admin/Header';
import Popup from './components/Admin/Popup';
import authRequets from './components/api/authRequests';

export default function Layout() {
    const { popup } = useContext(popupContext)

    const { user } = useContext(userContext);


    // if user is connected
    if (user && user.permissions != "viewer") {

        return (
            <>
                <Header />
                <MainAdmin />
                {popup && <Popup />}
            </>)

        // routes without auth
    } else {
        // authRequets.signOutUser()
        return (
            <Routes>
                <Route path='/login' element={<Login />} />
                <Route path='*' element={<Navigate to={"/login"} />} />
            </Routes>
        )
    }

}
